import axios from 'axios';

const headers = { headers: {}, withCredentials: true };

export const getService = async (baseUrl) => {
  try {
    const response = await axios.get(baseUrl, headers);
    return [response?.data?.data, null];
  } catch ({ response: { data = {} } }) {
    return [null, data];
  }
};

export const postService = async (baseUrl, params) => {
  try {
    const response = await axios.post(baseUrl, params, headers);
    return [response?.data?.data, null];
  } catch ({ response: { data = {} } }) {
    return [null, data];
  }
};

export const putService = async (baseUrl, params) => {
  try {
    const response = await axios.put(baseUrl, params, headers);
    return [response?.data?.data, null];
  } catch ({ response: { data = {} } }) {
    return [null, data];
  }
};

export const deleteService = async (baseUrl, params) => {
  try {
    const response = await axios.delete(baseUrl, params, headers);
    return [response?.data?.data, null];
  } catch ({ response: { data = {} } }) {
    return [null, data];
  }
};
